import React from "react";
import styled from "styled-components";
import Icon from "../atoms/Icon";
import colours from "../../lib/colours";

import "../../css/search-widget.css";
import appConfig from "../../lib/appConfig";
import CloseButton from "../atoms/CloseButton";

const inputPrepend = 50;
const searchbarMargins = 30;
const fullscreenSearchBp =
  appConfig.leftNavWidth +
  appConfig.dataPanelWidth +
  appConfig.searchInputWidth +
  searchbarMargins +
  inputPrepend;
const rightAnchoredSearchBp = 1400; // ensures enough space for layers button. Also hardcoded in index.css
const fullscreenSearchMobileBp = 520;

const StyledSearchContainer = styled.div`
  display: flex;
  position: absolute;
  background-color: rgba(255, 255, 255, 1);
  z-index: 3;
  color: ${colours.white};
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.25);
  margin-top: 16px;

  &:focus-within {
    z-index: 4;
  }

  /* desktop centered */
  left: 50%;
  transform: translate(-50%);

  /* desktop right anchored */
  @media (max-width: ${rightAnchoredSearchBp}px) {
    left: unset;
    right: ${searchbarMargins / 2}px;
    transform: none;
  }

  /* desktop full width (except when data panel is hidden) */
  @media (max-width: ${fullscreenSearchBp}px) {
    width: calc(100% - ${searchbarMargins}px);
    max-width: ${appConfig.searchInputWidth}px;
  }

  /* mobile right anchored */
  @media (max-width: ${appConfig.tabletWidth}px) {
    width: ${appConfig.searchInputWidth}px;
    right: ${searchbarMargins / 2}px;
    left: unset;
  }

  /* mobile full width */
  @media (max-width: ${fullscreenSearchMobileBp}px) {
    width: calc(100% - ${searchbarMargins}px);
    left: ${searchbarMargins / 2}px;
  }
`;
const StyledInputPrepend = styled.div`
  box-sizing: border-box;
  align-items: center;
  margin-bottom: 0;
  color: ${colours.th1};
  text-align: center;
  display: flex;
  float: left;
  font-size: 18px;
  padding-left: 18px;
  padding-right: 12px;
  width: ${inputPrepend}px;
  background: ${colours.white};
  border-right: 1px solid ${colours.th1l2};
`;

const StyledInput = styled.div`
  background-color: ${colours.white};
  border-left: 0;
  height: 42px;
  padding-right: 3px;
  width: ${appConfig.searchInputWidth}px !important;

  /* desktop full width (except when data panel is hidden) */
  @media (max-width: ${fullscreenSearchBp}px) {
    width: 100% !important;
  }

  /* mobile right anchored */
  @media (max-width: ${appConfig.tabletWidth}px) {
    width: ${appConfig.searchInputWidth}px !important;
  }

  /* mobile full width */
  @media (max-width: ${fullscreenSearchMobileBp}px) {
    width: 100% !important;
  }
`;

const CloseButtonContainer = styled.div`
  position: absolute;
  top: 3px;
  right: 0;
  z-index: 1;
`;
interface IProps {
  clearVisible: boolean;
  clearSearch: any;
}

const SearchControl = ({ clearVisible, clearSearch }: IProps) => {
  return (
    <StyledSearchContainer>
      <StyledInputPrepend>
        <Icon icon="map-marker-alt" />
      </StyledInputPrepend>
      <StyledInput id="mapSearchWidgetInput" />
      {clearVisible && (
        <CloseButtonContainer>
          <CloseButton fontSize={"20px"} onClick={clearSearch} />
        </CloseButtonContainer>
      )}
    </StyledSearchContainer>
  );
};

export default SearchControl;
